import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { Container, SmallScreenOnly } from '../../utils/style'
import { Box } from 'rebass'
import buildPath from '../../../lib/cars/used/path-builder.js'
import IconFormArrowRight from '../../vectors/IconFormArrowRight'
import { Link } from 'gatsby'

const Wrapper = styled(Box)`
  background-color: ${(props) => props.theme.colors.blue_mid};

  a {
    text-transform: uppercase;
    text-decoration: none;
    font-weight: ${(props) => props.theme.weights[1]};
    font-size: ${(props) => rem(props.theme.fontSizes[1])};
    color: ${(props) => props.theme.colors.grey_op65};
  }

  svg {
    transform: rotate(180deg);
    margin-right: 10px;
    width: 10px;
    height: 10px;
  }

  path {
    fill: ${(props) => props.theme.colors.grey_op65};
  }
`

class Breadcrumbs extends React.PureComponent {
  render() {
    const categoryPath = buildPath(this.props.category, false)

    return (
      <div key="mobile-breadcrumbs" id="mobile-breadcrumbs">
        <SmallScreenOnly>
          <Wrapper width={12 / 12} pt={'8px'} pb={'8px'}>
            <Container mx={'5%'} px={0} maxWidth={'100%'} id={this.props.id}>
              <Link to={categoryPath}>
                <IconFormArrowRight />
                <span>Back to all used</span>
              </Link>
            </Container>
          </Wrapper>
        </SmallScreenOnly>
      </div>
    )
  }
}

export default Breadcrumbs
